
export const GET_STUDENT = "/getStudents";
export const SHOW = "/show";
export const PAGE = "?page";